/* eslint-disable */
/**
 * Polyfill for ReactDOM.findDOMNode which was removed in React 19
 * This is a minimal implementation to support legacy libraries like react-quill-new
 */

import ReactDOM from 'react-dom'

if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = function (component) {
    if (component == null) {
      return null
    }

    // If it's already a DOM node, return it
    if (component.nodeType === 1) {
      return component
    }

    // If it's a React component instance with a fiber
    if (component._reactInternals) {
      let fiber = component._reactInternals

      // Walk the fiber tree to find the DOM node
      while (fiber) {
        if (fiber.stateNode && fiber.stateNode.nodeType === 1) {
          return fiber.stateNode
        }
        fiber = fiber.child
      }
    }

    // Fallback: try to access stateNode directly (for class components)
    if (component.stateNode && component.stateNode.nodeType === 1) {
      return component.stateNode
    }

    console.warn(
      'findDOMNode polyfill: Could not find DOM node for component',
      component,
    )
    return null
  }
}
